import React, { useEffect, useState } from "react";
import "../../styles/style.css";
import { Link } from "react-router-dom";
import NavbarDashboard from "../Navbar/NavbarDashboard";
import "../../styles/style.css";

const AlreadyTaken = () => {
  return (
    <div className="container-dashboard">
    <NavbarDashboard />
      <div className="taken_wrapper">
        <h3>You have already taken this test.</h3>
        <Link to="/progress" className="taken_button">
          Back to Progress
        </Link>
      </div>
    </div>
  );
};

export default AlreadyTaken;
